import { API_BASE_URL } from "../configs/api";

// const ACCESS_TOKEN = JSON.parse(localStorage.getItem("token"));

export function getAccessToken() {
  const rawToken = localStorage.getItem("token");
  let accessToken = null;

  try {
    accessToken = rawToken ? JSON.parse(rawToken) : null;
  } catch (e) {
    console.error("Failed to parse token:", e);
  }

  return accessToken;
}

function handleResponse(response) {
  if (response.status === 401) {
    // Unauthorized - redirect to login/default page
    window.location.href = "/";
    return;
  }
  return response;
}


export function get(request, options) {
  const url = new URL(API_BASE_URL + request);
  const ACCESS_TOKEN = getAccessToken();

  options.headers = new Headers({
    "Content-Type": "application/json",
    "Authorization": `Bearer ${ACCESS_TOKEN}`,
  });

  return new Promise((resolve, reject) => {
    fetch(url, {
      method: "GET",
      headers: options.headers,
      crossDomain: true,
    })
      .then(handleResponse)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function post(request, body = null, options) {
  const url = new URL(API_BASE_URL + request);
  const basePath = request.split("?")[0];
  const ACCESS_TOKEN = getAccessToken();

  options.headers = new Headers({
    "Content-Type": "application/json",
    "Authorization": `Bearer ${ACCESS_TOKEN}`,
  });

  // Modify options.headers for specific endpoints
  // if (basePath === "/MobileLogin") {
  //   options.headers = new Headers({
  //     "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
  //   });
  // }

  return new Promise((resolve, reject) => {
    fetch(url, {
      method: "POST",
      body: body ? JSON.stringify(body) : null,
      headers: options.headers,
      crossDomain: true,
    })
      .then(handleResponse)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function put(request, body, options) {
  const url = new URL(API_BASE_URL + request);
  const ACCESS_TOKEN = getAccessToken();

  options.headers = new Headers({
    "Content-Type": "application/json",
    "Authorization": `Bearer ${ACCESS_TOKEN}`,
  });

  return new Promise((resolve, reject) => {
    fetch(url, {
      method: "PUT",
      body: JSON.stringify(body),
      headers: options.headers,
      crossDomain: true,
    })
      .then(handleResponse)
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function remove(request, body=null, options) {
    const url = new URL(API_BASE_URL + request);
    const ACCESS_TOKEN = getAccessToken();
  
    options.headers = new Headers({
      "Content-Type": "application/json",
      "Authorization": `Bearer ${ACCESS_TOKEN}`,
    });
  
    return new Promise((resolve, reject) => {
      fetch(url, {
        method: "DELETE",
        headers: options.headers,
        body: body ? JSON.stringify(body) : null,
        crossDomain: true,
      })
        .then(handleResponse)
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }